<template>
	<div class="container-fluid bg-light">
		<div class="row d-flex justify-content-center align-items-center h-100">
			<div class="col-12 col-md-8 col-lg-6 border shadow rounded bg-white pt-5 pb-5">
				<div class="text-center mb-3">
					<p class="h4">
						Szivárvány AQUA - Office
					</p>
				</div>
				<div class="alert alert-danger" v-if="error">
					<p class="h4">{{error}}</p>
				</div>
				<form class="mui-form" @submit.prevent="login">
				  	<div class="mui-textfield mui-textfield--float-label">
				    	<input
				    		type="text"
				    		required
				    		v-model="email"
				    	>
				    	<label>
				    		Felhasználónév
				    	</label>
				  	</div>
				  	<div class="mui-textfield mui-textfield--float-label">
				    	<input
				    		type="password"
				    		required
				    		v-model="password"
				    	>
				    	<label>
				    		Jelszó
				    	</label>
				  	</div>
				  	<button type="submit" class="mui-btn mui-btn--raised">
				  		Belépés
				  	</button>
				</form>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'login',

	data() {
		return {
			email: '',
      		password: '',
      		error: ''
		}
	},

	methods: {
		login() {
      		this.req_auth.post(`/login`, {
          		user: this.email,
          		password: this.password
        	})
      			.then(res => this.loginSuccessful(res) )
      			.catch(err => this.loginFailed(err) )
    	},
    
    	loginSuccessful(req) {
	      	if (!req.data.token) {
	        	this.loginFailed(`Denied`)
	        	return
	      	}
	      	this.$store.dispatch('setuser', req.data)
	      	this.$store.dispatch('settoken', req.data.token)
	      	this.error = false
	      	this.$router.replace('/')
    	},
    
    	loginFailed(error) {
      		this.error = error
      		this.$store.dispatch('setuser', null)
      		this.$store.dispatch('settoken', null)
    	}
	}
}
</script>
<style type="text/css" scoped>
.container-fluid {
	min-height: 100% !important;
	height: 100vh;
}
</style>

<!--<template>
<div class="container-fluid">
	<div class="row d-flex justify-content-center mt-5">
		<div class="col-12 col-sm-12 col-md-10 col-lg-8">
			<div class="alert alert-danger text-center h2" v-if="error">{{ error }}</div>	
		</div>
		<div class="col-12 col-sm-12 col-md-10 col-lg-8 mb-3 mt-3">
			<div class="h2 text-center">Jelentkezz be</div>
		</div>
	</div>
	<div class="row d-flex justify-content-center">
		<div class="col-12 mb-3">
			<div class="row d-flex justify-content-center">
				<div class="col-12 col-sm-8 col-md-6 col-lg-6">
					<div class="input-group">
		                <div class="input-group-prepend">
		                	<span class="input-group-text">
		                    	<i class="fas fa-user-circle"></i>
		                  	</span>
		                </div>
		                <input v-model="email" class="form-control text-center" placeholder="Felhasználónév" required autofocus v-on:keyup.13="login">
		            </div>	
				</div>
			</div>
		</div>
		<div class="col-12 mb-3">
			<div class="row d-flex justify-content-center">
				<div class="col-12 col-sm-8 col-md-6 col-lg-6">
					<div class="input-group">
		                <div class="input-group-prepend">
		                	<span class="input-group-text">
		                    	<i class="fas fa-key"></i>
		                  	</span>
		                </div>
		                <input v-model="password" type="password" class="form-control text-center" placeholder="Jelszó" required v-on:keyup.13="login">
		            </div>	
				</div>
			</div>
		</div>
		<div class="col-12 text-center">
			<button class="btn btn-lg btn-outline-primary m-1" @click.prevent="login()">Belépek</button>
		</div>
	</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: '',
      error: ''
    }
  },
  created () {
    //if(this.$store.getters.token != null) this.$router.replace(this.$route.query.redirect || '/')
  },
  methods: {
    login() {
      this.req_auth.post(`/login`, {
          user: this.email,
          password: this.password
        })
      .then(res => this.loginSuccessful(res) )
      .catch(err => this.loginFailed(err) )
    },
    loginSuccessful(req) {
      if (!req.data.token) {
        this.loginFailed(`Denied`)
        return
      }
      this.$store.dispatch('setuser', req.data)
      console.log(req.data)
      this.$store.dispatch('settoken', req.data.token)
      this.error = false
      this.$router.replace('/')
    },
    loginFailed(error) {
      this.error = error
      this.$store.dispatch('setuser', null)
      this.$store.dispatch('settoken', null)
    }
  }
}
</script>

<style scoped>
</style>-->



// WEBPACK FOOTER //
// src/components/login.vue